import type { WLRootState } from '../../WLOrderFormStore';

export const selectIsBiometricallyVerified = (state: WLRootState) => state.session.isBiometricallyVerified;
export const selectArchivedOrderIDSet = (state: WLRootState) => state.session.archivedOrderIDSet;
